import { render, staticRenderFns } from "./Register_student.vue?vue&type=template&id=eb595d58&scoped=true"
import script from "./Register_student.vue?vue&type=script&lang=js"
export * from "./Register_student.vue?vue&type=script&lang=js"
import style0 from "./Register_student.vue?vue&type=style&index=0&id=eb595d58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb595d58",
  null
  
)

export default component.exports